<div class="container mx-auto px-0 py-0">
  <div class="bg-white rounded-lg" [ngClass]="{'shadow-md p-6': !isEmbedded, 'p-0': isEmbedded}" [style.border-top]="!isEmbedded ? 'solid #4caf50 4px' : 'none'">
    <!-- Standalone Header - Only show in standalone mode -->
    <div *ngIf="!isEmbedded" class="flex justify-between items-center mb-6">
      <div class="flex items-center space-x-2">
        <mat-icon>location_on</mat-icon>
        <h2 class="text-2xl font-bold mb-0">{{ 'STANDORT.TITLE' | translate }}</h2>
      </div>

      <div class="flex justify-end items-center gap-2">
        <button 
          [matMenuTriggerFor]="exportMenu" 
          mat-icon-button 
          [matTooltip]="'COMMON.EXPORT' | translate"
          aria-label="Export">
          <mat-icon>file_download</mat-icon>
        </button>
        <mat-menu #exportMenu="matMenu">
          <button mat-menu-item (click)="exportToCSV()">
            <mat-icon>description</mat-icon>
            <span>{{ 'COMMON.EXPORT_CSV' | translate }}</span>
          </button>
          <button mat-menu-item (click)="exportToExcel()">
            <mat-icon>table_chart</mat-icon>
            <span>{{ 'COMMON.EXPORT_EXCEL' | translate }}</span>
          </button>
        </mat-menu>
        <button (click)="addStandort()" mat-stroked-button>
          <mat-icon class="mr-1">add</mat-icon>
          {{ 'STANDORT.NEW' | translate }}
        </button>
      </div>
    </div>

    <!-- Embedded Header - Only show in embedded mode -->
    <div *ngIf="isEmbedded" class="flex justify-end items-center gap-2 mb-4 mt-4">
      <button 
        [matMenuTriggerFor]="exportMenuEmbedded" 
        mat-icon-button 
        [matTooltip]="'COMMON.EXPORT' | translate"
        aria-label="Export">
        <mat-icon>file_download</mat-icon>
      </button>
      <mat-menu #exportMenuEmbedded="matMenu">
        <button mat-menu-item (click)="exportToCSV()">
          <mat-icon>description</mat-icon>
          <span>{{ 'COMMON.EXPORT_CSV' | translate }}</span>
        </button>
        <button mat-menu-item (click)="exportToExcel()">
          <mat-icon>table_chart</mat-icon>
          <span>{{ 'COMMON.EXPORT_EXCEL' | translate }}</span>
        </button>
      </mat-menu>
      <button (click)="addStandort()" mat-stroked-button>
        <mat-icon class="mr-1">add</mat-icon>
        {{ 'STANDORT.NEW' | translate }}
      </button>
    </div>

    <!-- Search and Filter - Only show in standalone mode -->
    <div *ngIf="!isEmbedded" class="mb-6">
      <div class="flex flex-row gap-4 items-center">
        <!-- Search Box -->
        <div class="flex-1">
          <div class="w-full max-w-sm min-w-[200px]">
            <div class="relative">
              <input
                class="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded-md pl-3 pr-28 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 shadow-sm focus:shadow"
                [placeholder]="'STANDORT.SEARCH' | translate"
                [(ngModel)]="searchTerm"
                (keyup)="onSearchInput($event)"
                (focus)="onSearchFocus()"
                (blur)="onSearchBlur()"
              />
              <button
                class="absolute top-1 right-1 flex items-center rounded bg-slate-800 py-1 px-2.5 border border-transparent text-center text-sm text-white transition-all shadow-sm hover:shadow focus:bg-slate-700 focus:shadow-none active:bg-slate-700 hover:bg-slate-700 active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                type="button"
                *ngIf="searchTerm"
                (click)="clearSearch()"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4 mr-2">
                  <path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                </svg>
                {{ 'COMMON.CLEAR' | translate }}
              </button>
              
              <!-- Search History Dropdown -->
              <div 
                *ngIf="showSearchHistory && searchHistory.length > 0"
                class="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto dark:bg-gray-800 dark:border-gray-600"
              >
                <div class="px-3 py-1.5 text-xs font-semibold text-gray-500 border-b border-gray-200 dark:text-gray-400 dark:border-gray-700 flex items-center justify-between">
                  <span>{{ 'COMMON.SEARCH_RECENT' | translate }}</span>
                  <button
                    type="button"
                    class="px-1.5 py-0.5 text-[10px] border border-gray-300 rounded bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                    (mousedown)="clearSearchHistory()"
                  >
                    {{ 'COMMON.CLEAR' | translate }}
                  </button>
                </div>
                <div 
                  *ngFor="let term of searchHistory"
                  (mousedown)="selectSearchHistory(term)"
                  class="px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer text-sm text-gray-700 dark:text-gray-300 transition-colors"
                >
                  <div class="flex items-center gap-2">
                    <mat-icon class="!w-4 !h-4 !text-base text-gray-400 dark:text-gray-500">history</mat-icon>
                    <span>{{ term }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Kunde Autocomplete Filter -->
        <div class="flex-none">
          <div class="relative">
            <input
              type="text"
              class="inline-flex w-full justify-start gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20 min-w-[140px]"
              [placeholder]="'COMMON.SEARCH_CLIENT' | translate"
              [(ngModel)]="kundeSearchValue"
              (input)="onKundeSearch($event)"
              (focus)="showKundeAutocomplete = true"
              (blur)="onKundeBlur()"
              [value]="getKundeDisplayValue()"
            />
            
            <!-- Clear button for Kunde -->
            <button
              *ngIf="selectedKunde"
              type="button"
              class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
              (click)="clearKundeFilter()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
                <path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
              </svg>
            </button>

            <!-- Kunde Autocomplete Dropdown -->
            <div
              *ngIf="showKundeAutocomplete && filteredKunden.length > 0"
              class="absolute left-0 z-50 mt-2 w-80 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-800 dark:ring-white/10 max-h-60 overflow-y-auto">
              <div class="py-1" role="none">
                <button
                  *ngFor="let kunde of filteredKunden"
                  type="button"
                  class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-white dark:focus:bg-white/5 dark:focus:text-white"
                  role="menuitem"
                  tabindex="-1"
                  (click)="selectKunde(kunde)">
                  <div class="font-medium">{{ kunde.suchbegriff }}</div>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Techniker Autocomplete Filter -->
        <div class="flex-none">
          <div class="relative">
            <input
              type="text"
              class="inline-flex w-full justify-start gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20 min-w-[160px]"
              [placeholder]="'COMMON.SEARCH_TECHNICIAN' | translate"
              [(ngModel)]="technikerSearchValue"
              (input)="onTechnikerSearch($event)"
              (focus)="showTechnikerAutocomplete = true"
              (blur)="onTechnikerBlur()"
              [value]="getTechnikerDisplayValue()"
            />
            
            <!-- Clear button for Techniker -->
            <button
              *ngIf="selectedTechniker"
              type="button"
              class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
              (click)="clearTechnikerFilter()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
                <path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
              </svg>
            </button>

            <!-- Techniker Autocomplete Dropdown -->
            <div
              *ngIf="showTechnikerAutocomplete && filteredTechniker.length > 0"
              class="absolute left-0 z-50 mt-2 w-80 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-800 dark:ring-white/10 max-h-60 overflow-y-auto">
              <div class="py-1" role="none">
                <button
                  *ngFor="let tech of filteredTechniker"
                  type="button"
                  class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-white dark:focus:bg-white/5 dark:focus:text-white"
                  role="menuitem"
                  tabindex="-1"
                  (click)="selectTechniker(tech)">
                  <div class="font-medium">{{ tech.vorname }} {{ tech.nachname }}</div>
                  <div class="text-xs text-gray-500" *ngIf="tech.funktion">{{ tech.funktion }}</div>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Status Filter - Rightmost -->
        <div class="flex-none">
          <div class="relative">
            <button 
              type="button"
              class="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20"
              (click)="toggleStatusDropdown($event)"
              [attr.aria-expanded]="statusDropdownOpen"
              aria-haspopup="listbox">
              {{ getStatusLabel() }}
              <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="-mr-1 h-5 w-5 text-gray-400">
                <path d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
            </button>

            <div 
              *ngIf="statusDropdownOpen"
              class="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-800 dark:ring-white/10"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="menu-button"
              tabindex="-1">
              <div class="py-1" role="none">
                <button
                  type="button"
                  class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-white dark:focus:bg-white/5 dark:focus:text-white"
                  role="menuitem"
                  tabindex="-1"
                  (click)="onStatusChange(null)"
                  [class.bg-gray-100]="selectedStatus === null"
                  [class.text-gray-900]="selectedStatus === null">
                  {{ 'COMMON.ALL_STATUS' | translate }}
                </button>
                <button
                  type="button"
                  class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-white dark:focus:bg-white/5 dark:focus:text-white"
                  role="menuitem"
                  tabindex="-1"
                  (click)="onStatusChange(1)"
                  [class.bg-gray-100]="selectedStatus === 1"
                  [class.text-gray-900]="selectedStatus === 1">
                  {{ 'COMMON.ACTIVE' | translate }}
                </button>
                <button
                  type="button"
                  class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-white dark:focus:bg-white/5 dark:focus:text-white"
                  role="menuitem"
                  tabindex="-1"
                  (click)="onStatusChange(2)"
                  [class.bg-gray-100]="selectedStatus === 2"
                  [class.text-gray-900]="selectedStatus === 2">
                  {{ 'COMMON.INACTIVE' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Alphabet Filter Bar -->
      <div class="w-full mt-3">
        <div class="flex flex-wrap gap-1 items-center">
          <!-- Alle Button -->
          <button
            type="button"
            (click)="onAlphabetFilterClick(null)"
            [style.background-color]="selectedAlphabetFilter === null ? '#e5e7eb' : 'white'"
            [style.color]="selectedAlphabetFilter === null ? '#374151' : '#374151'"
            class="px-3 py-1 text-xs font-semibold rounded-md shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:ring-white/5 dark:hover:bg-white/20 transition-colors text-center dark:bg-white/10 dark:text-white"
          >
            {{ 'COMMON.ALL' | translate }}
          </button>
          <!-- Letter Buttons -->
          <button
            *ngFor="let letter of 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')"
            type="button"
            (click)="onAlphabetFilterClick(letter)"
            [style.background-color]="selectedAlphabetFilter === letter ? '#3f51b5' : 'white'"
            [style.color]="selectedAlphabetFilter === letter ? 'white' : '#374151'"
            class="px-2 py-1 text-xs font-semibold rounded-md shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:ring-white/5 dark:hover:bg-white/20 transition-colors min-w-[32px] text-center dark:bg-white/10 dark:text-white"
          >
            {{ letter }}
          </button>
        </div>
      </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="loading" class="flex justify-center items-center py-8">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
    </div>

    <!-- Error Message -->
    <div *ngIf="!loading && dataSource.data.length === 0" class="text-center py-8">
      <mat-icon class="text-gray-400 text-6xl mb-4">location_on</mat-icon>
      <p class="text-gray-500 text-lg">{{ 'STANDORT.NO_DATA' | translate }}</p>
    </div>

    <!-- Standorte Table -->
    <div class="mt-8 flow-root" *ngIf="!loading && dataSource.data.length > 0">
      <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <table class="relative min-w-full divide-y divide-gray-300 dark:divide-white/15">
            <thead>
              <tr>
                <th scope="col" class="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0 dark:text-white">{{ 'STANDORT.COL_NAME' | translate }}</th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">{{ 'STANDORT.COL_TECHNICIAN' | translate }}</th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">{{ 'STANDORT.COL_ADDRESS' | translate }}</th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">{{ 'STANDORT.COL_INTERVAL' | translate }}</th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">{{ 'COMMON.STATUS' | translate }}</th>
                <th scope="col" class="whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-0">
                  <span class="sr-only">{{ 'COMMON.ACTIONS' | translate }}</span>
                </th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 bg-white dark:divide-white/10 dark:bg-gray-900">
              <tr 
                *ngFor="let standort of dataSource.data; let i = index" 
                (click)="showPageDetail(standort.id.toString())" 
                class="cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-150"
                [ngClass]="{'bg-gray-50 dark:bg-gray-800': i % 2 === 1}">
                <td class="whitespace-nowrap py-1 pl-4 pr-3 text-sm sm:pl-0">
                  <div class="font-medium text-gray-900 dark:text-white">{{ standort.name }}</div>
                  <div class="text-xs text-gray-500 dark:text-gray-400 mt-0.5" *ngIf="standort.kunde?.suchbegriff">{{ getClientName(standort) }}</div>
                </td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">{{ getTechnicianName(standort) }}</td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">{{ getFormattedAddress(standort) }}</td>
                <td class="whitespace-nowrap px-2 py-2 text-sm">
                  <div class="text-gray-500 dark:text-gray-400">{{ getPeriodizitaetLabel(standort) }}</div>
                  <div class="text-xs text-gray-400 dark:text-gray-500 mt-0.5" *ngIf="getPeriodizitatSerieLabel(standort)">{{ getPeriodizitatSerieLabel(standort) }}</div>
                </td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                  <span class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset"
                        [ngClass]="getStatusClasses(standort.status)">
                    {{ getStatusText(standort.status) }}
                  </span>
                </td>
                <td class="whitespace-nowrap py-1 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                  <button
                    (click)="showPageDetail(standort.id.toString()); $event.stopPropagation()"
                    mat-button
                    color="primary"
                    class="slim-button">
                    {{ 'COMMON.EDIT' | translate }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Paginator -->
    <mat-paginator
      *ngIf="!loading && dataSource.data.length > 0"
      [length]="totalItems"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      (page)="onPageChange($event)"
      showFirstLastButtons
      aria-label="Select page of locations">
    </mat-paginator>
  </div>
</div>
